// src/components/CommentsMenu.js

import React, { useState } from 'react';
import {
  IconButton,
  Menu,
  MenuItem,
  Typography,
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

function CommentsMenu({ comments }) {
  const [anchorEl, setAnchorEl] = useState(null);

  const hasComments = comments && comments.trim() !== '';

  const handleCommentsClick = (event) => {
    if (hasComments) {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleCommentsClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        onClick={handleCommentsClick}
        aria-label="comments"
        color={hasComments ? 'error' : 'default'}
        disabled={!hasComments}
        sx={{ fontSize: "18px", opacity: hasComments ? 0.8 : 0.2 }}
      >
        <InfoIcon  sx={{ fontSize: '18px' }} />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCommentsClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <MenuItem disabled>
          <Typography variant="subtitle1">Comments</Typography>
        </MenuItem>
        <MenuItem>
          <Typography variant="body2">
            {comments || 'No comments available.'}
          </Typography>
        </MenuItem>
      </Menu>
    </>
  );
}

export default CommentsMenu;